import { useEffect } from "react";
import { useSelector } from "react-redux";

export function Head() {

  const [ title, favicon ] = useSelector(({ app }) => [ app.appName, app.favicon ]);


  useEffect(() => {
    if (title) {
      document.title = `${title} | ${document.title}`;
    }
  }, [ title ]);

  useEffect(() => {
    if (favicon) {
      let links = document.querySelectorAll("link[rel~='icon']");

      if (0 === links.length) {
        const link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
        link.href = favicon;
      } else {
        links.forEach((link) => (link.href = favicon));
      }
    }
  }, [ favicon ]);

  return null;
};



// WEBPACK FOOTER //
// ./src/components/UI/Head.jsx